import React, { useState, useEffect, useRef, Component } from "react";
import styled from "styled-components";
import reorderBackground from "../assets/reorderNumpad.png";

var answer1;
var answer2;

class AsCalculatorClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      boxSelected: 1,//1 is first box 2 is second box
      answer1: "",
      answer2: "",
      units: props.currentQuestion.units,
      answer: "",
      displayValue: "",
      showCorrectAnswer: false,
      currentQuestion: props.currentQuestion,
      localQuestion: [], 
      update: false
    };
    this.child = React.createRef();

    this.AddNumber=this.AddNumber.bind(this);
    this.downHandler=this.downHandler.bind(this);
    this.downHandler2=this.downHandler2.bind(this);
    //this.handleInputChange = this.handleInputChange.bind(this);
  }

  //if the question has changed blank the box
  componentDidUpdate(prevProps) {
    console.log("PREVIOUS PROPS");
    console.log(prevProps);
    console.log("CURRENT PROPS");
    console.log(this.props.currentQuestion);
    
    if (prevProps.currentQuestion != this.props.currentQuestion){
      this.setState({units: this.props.currentQuestion.units});
      console.log(this.props.currentAnswer);
      if (this.props.currentAnswer == ""){
        this.setState({answer1: ""})
        this.setState({answer2: ""})
        this.setState({displayValue: ""});
      }else{
        //split it up
        console.log("this exists so split it up");
        var array = this.props.currentAnswer.split("/");
        this.setState({answer1: array[0]})
        this.setState({answer2: array[1]})
        this.setState({displayValue: this.props.currentAnswer});
      }
      console.log("PROPS CHANGED");
      console.log(prevProps);
      }
  }

  componentDidMount(){
    if (this.props.currentAnswer != ""){
      var array = this.props.currentAnswer.split("/");
        this.setState({answer1: array[0]})
        this.setState({answer2: array[1]})
        this.setState({units: this.props.currentQuestion.units});
        this.setState({displayValue: this.props.currentAnswer});
    }
  }

  

     
  
  AddNumber(value) {
    console.log("ADDING NUMBER");
    console.log(this.state);
    console.log(this);
    
    //SAVES IT IN OTHER METHOD, DONE FIRST BECAUSE STUPID SETSTATE DELAY
    this.props.onChange(this.state.answer+value.toString());
    //this.state.answer = [...this.state.answer, value];
    this.setState({answer: this.state.answer + value.toString()})
    //this.state.displayValue = this.state.answer.join("");
    this.setState({displayValue: this.state.answer});
    this.setState({ update: !this.state.update });
    console.log("DISPLAY VALUE " + this.state.displayValue);
    //setTimeOutDisplayValue();
    
  }


  downHandler({ key }) {
    console.log("INPUT" + key)
    key = key.toString();
    if (this.state.answer1.length > 8 && key != "Delete" && key != "Backspace")
      return;
    switch (key) {
      case "1":
        this.setState({answer1: this.state.answer1 + 1}, this.UpdateAnswer(this.state.answer1 + 1))
        break;
      case "2":
        this.setState({answer1: this.state.answer1 + 2}, this.UpdateAnswer(this.state.answer1 + 2))
        break;
      case "3":
        this.setState({answer1: this.state.answer1 + 3}, this.UpdateAnswer(this.state.answer1 + 3))
        break;
      case "4":
        this.setState({answer1: this.state.answer1 + 4}, this.UpdateAnswer(this.state.answer1 + 4))
        break;
      case "5":
        this.setState({answer1: this.state.answer1 + 5}, this.UpdateAnswer(this.state.answer1 + 5))
        break;
      case "6":
        this.setState({answer1: this.state.answer1 + 6}, this.UpdateAnswer(this.state.answer1 + 6))
        break;
      case "7":
        this.setState({answer1: this.state.answer1 + 7}, this.UpdateAnswer(this.state.answer1 + 7))
        break;
      case "8":
        this.setState({answer1: this.state.answer1 + 8}, this.UpdateAnswer(this.state.answer1 + 8))
        break;
      case "9":
        this.setState({answer1: this.state.answer1 + 9}, this.UpdateAnswer(this.state.answer1 + 9))
        break;
      case "0":
        this.setState({answer1: this.state.answer1 + 0}, this.UpdateAnswer(this.state.answer1 + 0))
        break;
      case ".":
        this.setState({answer1: this.state.answer1 + "."}, this.UpdateAnswer(this.state.answer1 + "."))
        break;
      case "Backspace":
        this.setState({answer1: ""}, this.UpdateAnswer(""))
        break;
      case "Delete":
        this.setState({answer1: ""}, this.UpdateAnswer(""))
        break;
      default:
        break;
    }
    //this.setState({answer: this.state.answer1 + "/" + this.state.answer2})
    //this.setState({answer: this.state.answer1 + "/" + this.state.answer2}, this.UpdateAnswer())

    //this.state.displayValue = this.state.answer.join("");
    this.setState({displayValue: this.state.answer1 + "/" + this.state.answer2});
    this.setState({ update: !this.state.update });
    //setTimeOutDisplayValue();
    //this.props.onChange(this.state.answer);
    //this.props.onChange(this.state.answer);//do it twice just incase this works around the delay
  }

  downHandler2({ key }) {
    console.log("INPUT" + key)
    console.log(this.state.answer2.length);
    key = key.toString();
    if (this.state.answer2.length > 8 && key != "Delete" && key != "Backspace")
      return;

    switch (key) {
      case "1":
        this.setState({answer2: this.state.answer2 + 1}, this.UpdateAnswer2(this.state.answer2 + 1))
        break;
      case "2":
        this.setState({answer2: this.state.answer2 + 2}, this.UpdateAnswer2(this.state.answer2 + 2))
        break;
      case "3":
        this.setState({answer2: this.state.answer2 + 3}, this.UpdateAnswer2(this.state.answer2 + 3))
        break;
      case "4":
        this.setState({answer2: this.state.answer2 + 4}, this.UpdateAnswer2(this.state.answer2 + 4))
        break;
      case "5":
        this.setState({answer2: this.state.answer2 + 5}, this.UpdateAnswer2(this.state.answer2 + 5))
        break;
      case "6":
        this.setState({answer2: this.state.answer2 + 6}, this.UpdateAnswer2(this.state.answer2 + 6))
        break;
      case "7":
        this.setState({answer2: this.state.answer2 + 7}, this.UpdateAnswer2(this.state.answer2 + 7))
        break;
      case "8":
        this.setState({answer2: this.state.answer2 + 8}, this.UpdateAnswer2(this.state.answer2 + 8))
        break;
      case "9":
        this.setState({answer2: this.state.answer2 + 9}, this.UpdateAnswer2(this.state.answer2 + 9))
        break;
      case "0":
        this.setState({answer2: this.state.answer2 + 0}, this.UpdateAnswer2(this.state.answer2 + 0))
        break;
      case ".":
        this.setState({answer2: this.state.answer2 + "."}, this.UpdateAnswer2(this.state.answer2 + "."))
        break;
      case "Backspace":
        this.setState({answer2: ""}, this.UpdateAnswer2(""))
        break;
      case "Delete":
        this.setState({answer2: ""}, this.UpdateAnswer2(""))
        break;
      default:
        break;
    }
    //ANSWER = 1 / 2
    //this.setState({answer: this.state.answer1 + "/" + this.state.answer2})
    //this.setState({answer: this.state.answer1 + "/" + this.state.answer2}, this.UpdateAnswer())
    //this.state.displayValue = this.state.answer.join("");
    this.setState({displayValue: this.state.answer1 + "/" + this.state.answer2});
    this.setState({ update: !this.state.update });
    //setTimeOutDisplayValue();
    //this.props.onChange(this.state.answer);
    //this.props.onChange(this.state.answer);//do it twice just incase this works around the delay
  }

  handleInputChange(e) {
    console.log(e.target.value);
    this.setState({ value: e.target.value });
  }

  UpdateAnswer2(value){
    console.log("UPDATING ANSWER TO");
    console.log(this.state.answer1 + "/" + value);
    this.setState({answer: this.state.answer1 + "/" + value}, this.SendAnswerToParent(this.state.answer1 + "/" + value))
    console.log(this.state.answer);
  }

  //updateanswer1
  UpdateAnswer(value){
    console.log("UPDATING ANSWER TO");
    console.log(value + "/" + this.state.answer2);
    this.setState({answer: value + "/" + this.state.answer2}, this.SendAnswerToParent(value + "/" + this.state.answer2))
    console.log(this.state.answer);
    
  }

  SendAnswerToParent(value){
    this.props.onChange(value)
    console.log("did onchange" + value);
  }


  InputValue(key){
    console.log("KEY: " + key)
    if (this.state.boxSelected == 1){
      this.downHandler({key})
    }else{
      this.downHandler2({key})
    }
    //console.log(this.state.answer1)
    //console.log(this.state.answer2);
    //console.log(this.state.answer);
  }

  SwitchBox(value){
    this.setState({boxSelected: value});
    this.setState({boxSelected: value});
  }


   DefaultReturn(){
    
  
    let valueButtons = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  

    return (
      <CalculatorContainer update={this.state.update }>
      <CalculatorFrame>
      <UnitsDiv>
        {this.state.units}
        </UnitsDiv>

        <Question
          type="text"
          disabled
        >
        </Question>
            <Answer type="text" onKeyDown={this.downHandler} value={this.state.answer1}
            onClick={() => {
              this.SwitchBox(1)
            }}/>
            <FractionLine></FractionLine>
            <Answer type="text" onKeyDown={this.downHandler2} value={this.state.answer2} 
            onClick={() => {
              this.SwitchBox(2)
            }}/>

        <Numberpad>
          {valueButtons.map(value => (
            <CalcButton
              value={value}
              onClick={() => {
                //this.AddNumber(value)
                this.InputValue(value);
                //answer = [...answer, value];
              }}
            >
              {value}
            </CalcButton>
          ))}
          <CalcButton
            value={0}
            onClick={() => {
              //this.setState({answer: ""});
              //this.setState({displayValue: this.state.answer});
              this.InputValue("Backspace");
              //setTimeOutDisplayValue();
            }}
          >
            C
          </CalcButton>
          <CalcButton
            value={0}
            onClick={() => {
              this.InputValue("0");
              //this.setState({answer: this.state.answer + "0"});
              //this.setState({displayValue: this.state.answer});
              //if (this.state.answer != ""){
              //  this.props.onChange(this.state.answer);
              //}
              //setTimeOutDisplayValue();
            }}
          >
            0
          </CalcButton>
          <CalcButton
            value={0}
            onClick={() => {
              this.InputValue(".");
              //this.state.answer = [...this.state.answer, "."];
              //this.setState({answer: this.state.answer + "."});
              //this.setState({displayValue: this.state.answer});
              //if (this.state.answer != ""){
              //  this.props.onChange(this.state.answer);
              //}
              //setTimeOutDisplayValue();
            }}
          >
            .
          </CalcButton>
        </Numberpad>
      </CalculatorFrame>
    </CalculatorContainer>
    )
  }

  render(){
    return(
    this.DefaultReturn()
    )
  }
}

export default function AsCalculator({ ...props }) {
  
  return (
    <AsCalculatorClass {...props}></AsCalculatorClass>
  );
}


const UnitsDiv = styled.div`
  font-size: 100px;
  position: absolute;
  top: 19%;
  right: 500px;
  display: flex;
  justify-content: flex-end;
`

const FractionLine = styled.hr`
    border: none;
    width: 400px;
    height: 10px;
    color: black;
    background-color: black;
`;
const CalculatorFrame = styled.div`
  width: 500px;
  height: 600px;
  display: flex;
  flex-direction: column;
  //background: rgba(255, 255, 255, 0.7);
  //border-radius: 10px;
  display: relative;
  //border: 2px solid rgb(99, 99, 99);
`;

const CalculatorContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Numberpad = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

const OrderNumpad = styled.div`
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background-image: url(${reorderBackground});
  background-size: cover;
  margin-left: 30px;
  align-self: center;
  &:hover {
    cursor: pointer;
  }
`;

const Question = styled.div`
  height: 100px;
  line-height: 50px;
  font-size: 100px;
  margin: 15px 25px;
  text-align: center;
  user-select: none;
  font-weight: 600;
  border: none;
  position: relative;
  right: 100%;
  top : 25%;
`;

const Answer = styled.input`
  height: 100px;
  line-height: 50px;
  font-size: 4em;
  margin: 5px 10px;
  text-align: right;
  font-weight: 600;
  color: #000000;
  border: none;
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgb(0, 0, 0);
  align-self: center;
  width: 200px
`;

const CorrectAnswer = styled.input`
  height: 70px;
  line-height: 50px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  color: green;
`;

const CalcButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background: rgb(98, 108, 113);
  border: 2px solid rgb(52, 58, 63);
  color: #ffffff;

  padding: 0.5em;
  box-sizing: border-box;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }

  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;

const CancelButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background: rgb(234, 29, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 29, 19, 1) 0%,
    rgba(255, 60, 50, 1) 100%
  );

  border: 2px solid rgb(234, 29, 19);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const OKButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background-color: #999;
  background: rgb(25, 160, 63);
  background: linear-gradient(
    0deg,
    rgba(25, 160, 63, 1) 0%,
    rgba(43, 196, 86, 1) 100%
  );
  border: 2px solid rgb(25, 160, 63);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;
